import Stack from '@redbubble/design-system/src/Stack';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { useCarouselSectionContext } from './carouselSectionContext';

export interface CarouselContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const CarouselContainer: React.FC<CarouselContainerProps> = ({
  children,
  className,
}) => {
  const { analytics } = useCarouselSectionContext();
  const { ref, inView } = useInView({ triggerOnce: true });

  // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
  React.useEffect(() => {
    if (inView) {
      if (analytics.inViewTracking) analytics.inViewTracking();
    }
  }, [inView]);

  return (
    <Stack ref={ref} spacing="m" className={className}>
      {children}
    </Stack>
  );
};
